import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import CompassLayout from "@/components/compass/CompassLayout";
import { useCompass } from "@/context/CompassContext";
import { useAuth } from "@/context/AuthContext";
import { Compass } from "@phosphor-icons/react";
import { COUNTRY_FLAGS } from "@/data/compass";

const STEPS = [
  "Evaluando tu oportunidad…",
  "Analizando tus recursos y tiempos…",
  "Buscando alternativas más rápidas y sostenibles…",
  "Identificando puntos ciegos…",
  "Preparando tu ruta recomendada…",
];

export default function CompassAnalyzing() {
  const nav = useNavigate();
  const { draft, reset } = useCompass();
  const { user } = useAuth();
  const started = useRef(false);
  const [step, setStep] = React.useState(0);
  const firstName = (user?.name || "").split(" ")[0];
  const flag = draft.country ? COUNTRY_FLAGS[draft.country] || "" : "";

  useEffect(() => {
    const t = setInterval(() => setStep((s) => (s + 1) % STEPS.length), 1400);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    if (!draft.path || !draft.country || !draft.city) {
      nav("/brujula", { replace: true });
      return;
    }

    api.post("/compass/evaluate", {
      path: draft.path,
      country: draft.country,
      state: draft.state,
      city: draft.city,
      answers: draft.answers,
    }).then((r) => {
      // Do not reset draft yet — Result page may reference country/city for display.
      nav(`/brujula/resultado/${r.data.id}`, { replace: true });
    }).catch(() => {
      toast.error("No se pudo evaluar tu ruta. Intenta de nuevo.");
      nav("/brujula", { replace: true });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CompassLayout testid="page-compass-analyzing">
      <div className="min-h-[60vh] flex flex-col items-center justify-center text-center">
        <div className="w-20 h-20 border-2 border-foreground flex items-center justify-center animate-pulse bg-primary text-primary-foreground">
          <Compass size={36} weight="bold" />
        </div>
        <h1 className="display text-3xl md:text-4xl mt-6 leading-tight">
          {firstName
            ? <>Analizando tu ruta, <span className="whitespace-nowrap">{firstName}</span>.</>
            : "Analizando tu ruta"}
        </h1>
        {draft.city && (
          <p className="mt-2 label-mono text-muted-foreground" data-testid="analyzing-location">
            {flag} {draft.city}{draft.country ? `, ${draft.country}` : ""}
          </p>
        )}
        <p className="mt-4 max-w-md text-sm text-muted-foreground" data-testid="analyzing-step">
          {STEPS[step]}
        </p>
        <div className="mt-6 label-mono text-muted-foreground">Esto puede tomar unos segundos</div>
      </div>
    </CompassLayout>
  );
}
